import React, { useContext, useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import * as yup from "yup";
import { Grid } from "@mui/material";
import { Form } from "react-final-form";
import Stack from "@mui/material/Stack";
import FormControlLabel from "@mui/material/FormControlLabel";
import UiSwitch from "../../../_uiComponents/common/form/UiSwitch";
import UiInput from "../../../_uiComponents/UiInput";
import UiSelect from "../../../_uiComponents/common/form/UiSelect";
import MultiSelect from "../../../_uiComponents/common/form/MultiSelect";
import { UiButton } from "../../../_uiComponents/common/form/UiButton";
import Validator from "../../../../_helpers/validate.schema";
import { FORM_TYPE_EDIT, FORM_TYPE_ADD } from "../../../../_helpers/constants";
import {
     factTableGetAllSchemeAttributeRequest,
     factTableGetAllSchemaTypeRequest,
     lookupTableListRequest,
     dataTemplateGetAllSchemeAttributeRequest,
     dataTemplateGetAllTypesRequest,
     factTableListRequest,
     dataTemplateAddSchemaValueRequest,
} from "../../../../_redux/_actions";
import { Context } from "../../../../_context/Store";
import { contextApiActions } from "../../../../_redux/_constants";
import { dataTemplateValueUpdateRequest } from "../../../../_redux/_actions/dataTemplate.action";

const validateSchema = () =>
     yup.object().shape({
          name: yup.string().required("Name is required."),
          schemaTypeId: yup.string().required("Type is required."),
     });

const onValidate = async (values) => {
     return await Validator(values, validateSchema);
};

export default function DataTemplatesAddRowForm(props) {
     const actionDispatch = useDispatch();

     const [initialValues, setInitialValues] = useState({});
     const [fieldType, setFieldType] = useState(null);

     const { tableValueDetails,  lookupTableList, dataTemplateAttributeList, dataTemplateTypeUploadsList, factTableList, dataTableList } =
          useSelector((state) => {
               return {
                    tableValueDetails: state.dataTemplate.tableValueDetails,
                    dataTableList: state.dataTemplate.list.data,
                    lookupTableList: state.lookupTable.list.data,
                    dataTemplateAttributeList:state.dataTemplate.dataTemplateAttributeList,
                    dataTemplateTypeUploadsList:state.dataTemplate.dataTemplateTypeUploadsList,
                    factTableList: state.factTable.list.data,
               };
          });

     const [state, dispatch] = useContext(Context);

     useEffect(() => {
          if (props.type === FORM_TYPE_EDIT) {
               if (tableValueDetails !== null) {
                    const value = {
                         name: tableValueDetails.name,
                         schemaTypeId: tableValueDetails.schemaDataTypeId,
                         schemaAttributeId: tableValueDetails.attribute !== null ? tableValueDetails.attribute.id : 0,
                         lookupTableId: tableValueDetails.lookupTableId,
                         identifier: tableValueDetails.identifier,
                         required: tableValueDetails.required,
                         filterable: tableValueDetails.filterable,
                    };

                    setInitialValues({ ...value });
               }
          }

          if (props.type === FORM_TYPE_ADD) {
               setInitialValues({});
          }
     }, [tableValueDetails, dataTemplateAttributeList, lookupTableList]);

     useEffect(() => {
          const dataTemplateType = dataTableList.filter(datalist => datalist.id === props.tableId);
          actionDispatch(dataTemplateGetAllTypesRequest());
          actionDispatch(factTableGetAllSchemaTypeRequest());
          actionDispatch(
               lookupTableListRequest({
                    page: 1,
                    pageSize: 100,
               }),
          );
          actionDispatch(factTableListRequest({
               page: 1,
               pageSize: 100,
          }));
          
     actionDispatch(dataTemplateGetAllSchemeAttributeRequest({
          templateType: dataTemplateType[0]?.dataTemplateType === "Participant" ? 1 : 2
     }));

     }, []);


     const closeFormModal = () => {
          dispatch({
               type: contextApiActions.UI_MODAL_TOGGEL,
               payload: {
                    show: false,
               },
          });
     };

     const submit = async (values) => {
          let identifier = false;
          let required = false;
          let filterable = false;

          if (values.required) {
               required = true;
          }

          if (values.identifier) {
               identifier = true;
          }

          if(values.filterable) {
               filterable = true;
          }

          if (props.type === FORM_TYPE_EDIT) {
               actionDispatch(
                    dataTemplateValueUpdateRequest({
                         id: tableValueDetails.id,
                         name: values.name,
                         factTableId: props.factTableId,
                         schemaTypeId: values.schemaTypeId,
                         schemaAttributeId: values.schemaAttributeId,
                         lookupTableId: values.lookupTableId,
                         required: required,
                         filterable:filterable,
                         identifier: identifier,
                         dataTemplateId: props.tableId,
                         schemaDataTypeId:values.schemaTypeId,
                         closeFormModal,
                    }),
               );
          } else {
               actionDispatch(
                    dataTemplateAddSchemaValueRequest({
                         name: values.name,
                         factTableId: values.factTableId,
                         schemaTypeId: values.schemaTypeId,
                         schemaAttributeId: values.schemaAttributeId,
                         lookupTableId: values.lookupTableId,
                         required: required,
                         identifier: identifier,
                         filterable: filterable,
                         dataTemplateId: props.tableId,
                         closeFormModal,
                    }),
               );
          }
     };

     return (
          <Form
               onSubmit={submit}
               validate={onValidate}
               initialValues={initialValues}
               render={({ form, handleSubmit, values }) => {
                    return (
                         <form onSubmit={validateSchema}>
                              <>
                                   <Grid
                                        container
                                        spacing={2}
                                        sx={{
                                             mt: 1,
                                        }}
                                   >
                                        <Grid
                                             container
                                             spacing={2}
                                             sx={{ mt: 1 }}
                                        >
                                             <Grid item xs={12} lg={6}>
                                                  <UiInput
                                                       type="text"
                                                       label="Field Name"
                                                       name="name"
                                                       maxLength={50}
                                                       allowedCharacters={/^[a-zA-Z0-9_ ]+$/}
                                                  />
                                             </Grid>
                                             <Grid item xs={12} lg={6}>
                                                  <UiSelect
                                                       id="fact-table-add-value-type-field-id"
                                                       label="Field Type"
                                                       name="schemaTypeId"
                                                       onChange={(value) => {
                                                            const typeObj =
                                                            dataTemplateTypeUploadsList.find(
                                                                      (obj) =>
                                                                           obj.id ===
                                                                           value,
                                                                 );

                                                            setFieldType(
                                                                 typeObj.code,
                                                            );

                                                            form.change(
                                                                 "schemaAttributeId",
                                                                 "",
                                                            );
                                                       }}
                                                       options={dataTemplateTypeUploadsList.map(
                                                            (type) => {
                                                                 return {
                                                                      value: type.id,
                                                                      label: type.name,
                                                                 };
                                                            },
                                                       )}
                                                  />
                                             </Grid>

                                             {fieldType == "LOOKUP_TABLE" && (
                                                  <Grid item xs={12} lg={6}>
                                                       <UiSelect
                                                            id="fact-table-add-value-lookup-table-id-field"
                                                            label="Lookup table"
                                                            name="lookupTableId"
                                                            options={lookupTableList.map(
                                                                 (
                                                                      lookupTable,
                                                                 ) => {
                                                                      return {
                                                                           value: lookupTable.id,
                                                                           label: lookupTable.name,
                                                                      };
                                                                 },
                                                            )}
                                                       />
                                                  </Grid>
                                             )}



                                             {fieldType == "FACT_TABLE" && (
                                                  <Grid item xs={12} lg={6}>
                                                       <UiSelect
                                                            id="fact-table-add-value-lookup-table-id-field"
                                                            label="Fact table"
                                                            name="factTableId"
                                                            options={factTableList.map(
                                                                 (
                                                                      factTable,
                                                                 ) => {
                                                                      return {
                                                                           value: factTable.id,
                                                                           label: factTable.name,
                                                                      };
                                                                 },
                                                            )}
                                                       />
                                                  </Grid>
                                             )}

                                             {dataTemplateAttributeList.length != 0 && (
                                                  <Grid item xs={12} lg={6}>
                                                       <UiSelect
                                                            id="fact-table-add-value-fact-table-attribute-field"
                                                            label="Attribute"
                                                            name="schemaAttributeId"
                                                            options={dataTemplateAttributeList.map(
                                                                 (type) => {
                                                                      return {
                                                                           value: type.id,
                                                                           label: type.name,
                                                                      };
                                                                 },
                                                            )}
                                                       />
                                                  </Grid>
                                             )}
                                             <Grid item xs={12} lg="2">
                                                  <FormControlLabel
                                                       control={
                                                            <UiSwitch
                                                                 name="identifier"
                                                                 checked={
                                                                      props.type ==
                                                                      FORM_TYPE_ADD
                                                                           ? false
                                                                           : initialValues.identifier
                                                                 }
                                                            />
                                                       }
                                                       label="Identity"
                                                       labelPlacement="top"
                                                       sx={{ mt: 0 }}
                                                       className="sba-switch-label"
                                                  />
                                             </Grid>
                                             <Grid item xs={12} lg="2">
                                                  <FormControlLabel
                                                       control={
                                                            <UiSwitch
                                                                 name="required"
                                                                 checked={
                                                                      props.type ==
                                                                      FORM_TYPE_ADD
                                                                           ? false
                                                                           : initialValues.required
                                                                 }
                                                            />
                                                       }
                                                       label="Mandatory"
                                                       labelPlacement="top"
                                                       sx={{ mt: 0 }}
                                                       className="sba-switch-label"
                                                  />
                                             </Grid>
                                             <Grid item xs={12} lg="2">
                                                  <FormControlLabel
                                                       control={
                                                            <UiSwitch
                                                                 name="filterable"
                                                                 checked={
                                                                      props.type ==
                                                                      FORM_TYPE_ADD
                                                                           ? false
                                                                           : initialValues.filterable
                                                                 }
                                                            />
                                                       }
                                                       label="Filterable"
                                                       labelPlacement="top"
                                                       sx={{ mt: 0 }}
                                                       className="sba-switch-label"
                                                  />
                                             </Grid>

                                             <Stack
                                                  spacing={2}
                                                  direction="row"
                                                  justifyContent="end"
                                                  sx={{ width: "100%", mt: 3 }}
                                             >
                                                  <UiButton
                                                       onClick={() => {
                                                            form.reset();
                                                            setInitialValues(
                                                                 {},
                                                            );
                                                       }}
                                                       name="Clear"
                                                       variant="outlined"
                                                       size="small"
                                                  />
                                                  <UiButton
                                                       name="Save"
                                                       variant="contained"
                                                       size="small"
                                                       onClick={handleSubmit}
                                                  />
                                             </Stack>
                                        </Grid>
                                   </Grid>
                              </>
                         </form>
                    );
               }}
          />
     );
}
